import{useState as t,useCallback as o}from"react";var r={WILL_COPY:"コピー",COPPIED:"コピーしました"},e=e=>{var{text:i="",onCopyButtonAction:C}=e,[n,P]=t(r.WILL_COPY);return{tooltipText:n,onClickCopyButton:o((()=>{navigator.clipboard.writeText(i),P(r.COPPIED),C&&C(),setTimeout((()=>{P(r.WILL_COPY)}),5e3)}),[i])}};
/**
 * テキストをコピーするカスタムフック
 */export{r as TOOLTIP_TEXT,e as useCopyText};
